import { jsx as _jsx } from "react/jsx-runtime";

/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */
import { useEffect, useState, useRef } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import UISelectableBox from 'UIComponents/button/UISelectableBox';
import UpgradeProductProperties from 'self-service-api/constants/UpgradeProductProperties';
import { getUpgradeButtonText } from 'ui-addon-upgrades/_core/common/adapters/getUpgradeButtonText';
import { track } from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { getCorrectedUpgradeData } from '../_core/utils/getCorrectedUpgradeData';
import { PricingPageRedirectButtonPropsInterface } from './interfaces/pricingPageRedirectButtonInterface';
import { omit } from 'ui-addon-upgrades/utils'; // @ts-expect-error dependency missing types

import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import { getProducts } from 'self-service-api/api/getProducts';
import { getSkuIdFromApiName } from '../_core/utils/productUtils';
import { getProductInfoFromSkuId } from 'self-service-api/core/utilities/productUtils';
import { getSource } from 'ui-addon-upgrades/ums/utils';
import { getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
import { productsAndAddons, suiteStarter } from 'self-service-api/core/utilities/links';

const UIPricingPageRedirectButton = props => {
  const _isMounted = useRef(true);

  const {
    upgradeData,
    usageLimitBannerData,
    isSelectableBox,
    subscreen,
    children,
    isUpgradePoint,
    onClick,
    level,
    overrideHref
  } = props;
  const correctedUpgradeData = getCorrectedUpgradeData(upgradeData);
  const {
    upgradeProduct
  } = correctedUpgradeData;
  const propsToPass = omit(props, 'usageLimitBannerData', 'isSelectableBox', 'upgradeData', 'subscreen', 'isUpgradePoint', 'onClick', 'level', 'overrideHref');
  const source = getSource(correctedUpgradeData.app, correctedUpgradeData.screen, correctedUpgradeData.uniqueId);
  const upgradeLink = (UpgradeProductProperties[upgradeProduct] || {}).upgradeLink;
  const [products, setProducts] = useState();
  useEffect(() => {
    track('pricingPageRedirectButtonInteraction', {
      action: 'viewed',
      upgradeProduct,
      source,
      subscreen
    });

    if (isUpgradePoint) {
      track('interaction', Object.assign({
        action: 'viewed pricing page redirect',
        isPrimaryCta: level === 1,
        isSecondaryCta: level === 2
      }, usageLimitBannerData, {}, getUpgradeDataTrackingProperties(correctedUpgradeData, isUpgradePoint)));
    }
  }, [correctedUpgradeData, upgradeProduct, source, subscreen, isUpgradePoint, level, usageLimitBannerData]);
  useEffect(() => {
    if (_isMounted.current) {
      getProducts().then(response => {
        if (_isMounted.current) {
          setProducts(response);
        }
      });
    }
  }, [setProducts]);
  useEffect(() => {
    return function cleanup() {
      _isMounted.current = false;
    };
  }, []);
  const apiName = UpgradeProductToApiNameMap[upgradeProduct];

  const getRedirectLink = () => {
    //For ebx-633 suite starter page
    if (overrideHref) {
      return suiteStarter(correctedUpgradeData.uniqueId);
    }

    if (!products || !apiName) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return upgradeLink(correctedUpgradeData.uniqueId);
    }

    const productInfo = getProductInfoFromSkuId(products, getSkuIdFromApiName(products, apiName));

    if (productInfo) {
      const {
        productLevel
      } = productInfo; // @ts-expect-error ts-issue

      return upgradeLink(correctedUpgradeData.uniqueId, productLevel);
    }

    return productsAndAddons(); //fallback generic pricing page link
  };

  const handleUpgrade = () => {
    track('pricingPageRedirectButtonInteraction', {
      action: 'clicked',
      upgradeProduct,
      source,
      subscreen
    });

    if (isUpgradePoint) {
      track('interaction', Object.assign({
        action: 'clicked upgrade point'
      }, usageLimitBannerData, {}, getUpgradeDataTrackingProperties(correctedUpgradeData, isUpgradePoint)));
      track('interaction', Object.assign({
        action: 'clicked pricing page redirect',
        isPrimaryCta: level === 1,
        isSecondaryCta: level === 2
      }, usageLimitBannerData, {}, getUpgradeDataTrackingProperties(correctedUpgradeData, isUpgradePoint)));
    }

    if (onClick) onClick();
  };

  if (!upgradeLink) return null;

  if (isSelectableBox) {
    return /*#__PURE__*/_jsx(UISelectableBox, Object.assign({
      onClick: handleUpgrade
    }, propsToPass, {
      children: children
    }));
  }

  return /*#__PURE__*/_jsx(UIButton, Object.assign({
    target: "_blank",
    "data-reagan-primary-cta": true,
    "data-selenium": "pricing-page-redirect-button",
    onClick: handleUpgrade,
    href: getRedirectLink(),
    external: true,
    iconProps: {
      className: 'hidden'
    }
  }, propsToPass, {
    children: children || getUpgradeButtonText('upgrade', upgradeProduct)
  }));
};

UIPricingPageRedirectButton.defaultProps = {
  use: 'primary',
  isSelectableBox: false // only use this prop when absolutely needed

};
UIPricingPageRedirectButton.propTypes = PricingPageRedirectButtonPropsInterface;
export default UIPricingPageRedirectButton;